import { TaskStartDatePeriod } from "Models/task";
import { TFunction } from "react-i18next";
import * as yup from "yup";

export const changeTaskTimeSchema = (params: { translate: TFunction<"translation", undefined>; formatFunction: (date: Date, formatText: string) => string; }) => {
  const { translate, formatFunction } = params
  return yup.object().shape({
    isMultiDayTask: yup.boolean().nullable(),
    startDate: yup.date().when("period", {
      is: TaskStartDatePeriod.FIXED_TIME || TaskStartDatePeriod.MULTI_DAY,
      then: yup.date().required(translate("thisFieldIsRequired")).typeError(translate("thisFieldIsRequired")),
      otherwise: yup.date().nullable(),
    }),
    endDate: yup.date().when("isMultiDayTask", {
      is: true,
      then: yup.date().when("period", {
        is: TaskStartDatePeriod.FIXED_TIME || TaskStartDatePeriod.MULTI_DAY,
        then: yup
          .date()
          .required(translate("thisFieldIsRequired"))
          .typeError(translate("thisFieldIsRequired"))
          .min(yup.ref("startDate"), translate("endDateCantBeBeforeStartDate")),
        otherwise: yup.date().nullable(),
      }),
      otherwise: yup.date().nullable(),
    }),
    startTime: yup.string().when("period", {
      is: TaskStartDatePeriod.FIXED_TIME || TaskStartDatePeriod.CUSTOM,
      then: yup.string().required(translate("thisFieldIsRequired")).typeError(translate("thisFieldIsRequired")),
      otherwise: yup.string().nullable(),
    }),
    endTime: yup.string().when("period", {
      is: TaskStartDatePeriod.FIXED_TIME || TaskStartDatePeriod.CUSTOM,
      then: yup.string().required(translate("thisFieldIsRequired"))
        .test('end-time-greater-than-start-time', translate("endTimeMustBeGreaterThanStartTime"),
          function (value) {
            const { startDate, startTime: from } = this.parent;
            if (!from || !value) return true;

            const currentDate = formatFunction(new Date(startDate), "yyyy-MM-dd");
            const startTime = new Date(`${currentDate}T${from}`);
            const endTime = new Date(`${currentDate}T${value}`);

            return endTime > startTime;
          })
        .typeError(translate("thisFieldIsRequired")),
      otherwise: yup.string().nullable(),
    }),
    period: yup.number().required(translate("thisFieldIsRequired")),
    timeSlots: yup.array().when("isMultiDayTask", {
      is: true,
      then: yup.array().when("period", {
        is: TaskStartDatePeriod.VARIABLE_TIME,
        then: yup.array().min(2, translate("itShouldBeAtLeastTwoDates")).of(yup.object().shape({
          date: yup.string().required(translate("thisFieldIsRequired")).typeError(translate("thisFieldIsRequired")),
          from: yup.string().required(translate("thisFieldIsRequired")).typeError(translate("thisFieldIsRequired")),
          to: yup.string().required(translate("thisFieldIsRequired")).test('end-time-greater-than-start-time', translate("endTimeMustBeGreaterThanStartTime"), function (value) {
            const { date, from } = this.parent;
            if (!from || !value) return true;

            const currentDate = date.split("T")[0];
            const startTime = new Date(`${currentDate}T${from}`);
            const endTime = new Date(`${currentDate}T${value}`);

            return endTime > startTime;
          }),
        })).typeError(translate("thisFieldIsRequired")),
        otherwise: yup.array().nullable(),
      }),
      otherwise: yup.array().nullable(),
    }),
  });
}
